// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ConnectionErrorsEnum } from '@shared/commons/ConnectionEnums';
import { FINISH_BLOCK_TRANSFER } from '@shared/utils/CommonConst';
import { ConectionResultEnum } from '@shared/utils/Connections/connection.types';
import { DirectReportMessage, Message } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { ReportMessageSource } from '@shared/utils/Enums/Constants';
import { HistoryType } from '@shared/utils/History/HistoryType';
import { ReloadHistoryParams } from '@shared/utils/History/ReloadHistoryParams';
import { TFInfo } from '@shared/utils/History/TFInfo';
import { ClusterNodeGroupContainer } from './WebFix/GroupUtils/ClusterNodeGroupContainer';
import { HistoryProcessorWorker } from './WebFix/HistoryProcessorWorker';
import { DirectVendorBase } from './WebFix/DirectVendorBase';
import { PFixOTTRequestMessage, PFixTradingWebhookListRequest, PFixTradingWebhookRequestMessage } from './WebFix/Messages/MessagesImport';
import { ProcessorWorker } from './WebFix/ProcessorWorker';
export class PFSVendor extends DirectVendorBase {
    constructor() {
        super();
        this.stream = null;
        this.EPStream = null;
        this.tradeStreams = {};
        this.quoteStreams = {};
        // Full logingng
        this.FullLogSubscribed = false;
        this.FullLogHandler = null;
        this.ClusterNodesDict = new ClusterNodeGroupContainer([]);
        this.vendorName = 'PFIX';
    }
    ConnectProcessPromise(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.login = params.login;
            this.loginParams = params;
            return yield this.GetConnectionCredentials(params)
                .then((authenticationRequestResultData) => {
                var _a;
                if (this.EPStream) {
                    this.EPStream.Disconnect();
                }
                if (authenticationRequestResultData.ErrorInConnection) {
                    return authenticationRequestResultData;
                }
                if (authenticationRequestResultData.verificationMode) {
                    return authenticationRequestResultData;
                }
                this.ClusterNodesDict = authenticationRequestResultData.CngContainer;
                const itemTradeStreams = authenticationRequestResultData.CngContainer.getClusterNodeGroupsByMode(ProcessorWorker.MODE_TRADESTREAM);
                if (itemTradeStreams.length === 0) {
                    return {
                        Connected: false,
                        ConnectionStateCode: ConectionResultEnum.Error,
                        ErrorCode: ConnectionErrorsEnum.ERROR_UNKNOWN,
                        Text: 'connect.connection.tradestream.error',
                        ErrorInConnection: true
                    };
                }
                params.accessToken = authenticationRequestResultData.accessToken;
                const TradeStreamsArr = [];
                for (let i = 0, len = itemTradeStreams.length; i < len; i++) {
                    const urlPair = itemTradeStreams[i].GetUrlsPair();
                    const url = params.isSSL ? urlPair.useSSL : urlPair.noSSL;
                    const stream = new ProcessorWorker(ProcessorWorker.MODE_TRADESTREAM);
                    stream.OnNewMessageDelegate = this.MessageProcess.bind(this);
                    this.tradeStreams[url] = stream;
                    stream.StreamKey = url;
                    stream.OnConnectionLost = this.ConnectionLost.bind(this);
                    if (this.stream) {
                        const prevStreamDecoder = this.stream.FMsgDecoder;
                        const newStreamDecoder = stream.FMsgDecoder;
                        this.CopyStreamLinks(prevStreamDecoder, newStreamDecoder);
                    }
                    this.stream = stream;
                    if (this.FullLogSubscribed) {
                        stream.FullLogHandler = this.FullLogHandler;
                    }
                    const arrElement = stream.ConnectToServer(url, params);
                    TradeStreamsArr.push(arrElement);
                }
                const QuoteStreamsArr = [];
                const quoteTradeStreams = authenticationRequestResultData.CngContainer.getClusterNodeGroupsByMode(ProcessorWorker.MODE_QUOTESTREAM);
                if (quoteTradeStreams.length === 0) {
                    authenticationRequestResultData.Connected = true;
                    return authenticationRequestResultData;
                }
                for (let i = 0, len = quoteTradeStreams.length; i < len; i++) {
                    const urlPair = quoteTradeStreams[i].GetUrlsPair();
                    const url = params.isSSL ? urlPair.useSSL : urlPair.noSSL;
                    const stream = new ProcessorWorker(ProcessorWorker.MODE_QUOTESTREAM);
                    stream.OnNewMessageDelegate = this.MessageProcess.bind(this);
                    this.quoteStreams[url] = stream;
                    stream.StreamKey = url;
                    // Full logingng
                    if (this.FullLogSubscribed) {
                        stream.FullLogHandler = this.FullLogHandler;
                    }
                    const tradeMsgDecoder = (_a = this.stream) === null || _a === void 0 ? void 0 : _a.FMsgDecoder;
                    const historyMsgDecoder = stream.FMsgDecoder;
                    this.CopyStreamLinks(tradeMsgDecoder, historyMsgDecoder);
                    const arrElement = stream.ConnectToServer(url, params);
                    QuoteStreamsArr.push(arrElement);
                }
                let prTA = null;
                let prQA = null;
                if (TradeStreamsArr.length > 0) {
                    prTA = Promise.all(TradeStreamsArr);
                }
                if (QuoteStreamsArr.length > 0) {
                    prQA = Promise.all(QuoteStreamsArr);
                }
                return Promise.all([prTA, prQA]).then((fuckingResulus) => {
                    const TradeConnectionResultData = fuckingResulus[0];
                    const connectionResults = fuckingResulus[1];
                    let TradeConnected = true;
                    if (!isNullOrUndefined(TradeConnectionResultData)) {
                        for (let i = 0, len = TradeConnectionResultData.length; i < len; i++) {
                            TradeConnected = TradeConnectionResultData[i].Connected && TradeConnected;
                        }
                        if (!TradeConnected) {
                            return TradeConnectionResultData[0];
                        }
                        this.userSessionId = TradeConnectionResultData[0].userSessionId;
                        this.login = TradeConnectionResultData[0].login;
                    }
                    if (!isNullOrUndefined(connectionResults)) {
                        let quoteConnected = true;
                        for (let i = 0, len = connectionResults.length; i < len; i++) {
                            quoteConnected = connectionResults[i].Connected && quoteConnected;
                        }
                        authenticationRequestResultData.Connected = !!quoteConnected;
                    }
                    return authenticationRequestResultData;
                });
            })
                .then((ConnectionResultData) => {
                if (ConnectionResultData.isPasswordExpired) {
                    ConnectionResultData.ConnectionStateCode = ConectionResultEnum.NeedChangePassword;
                    return ConnectionResultData;
                }
                else if (ConnectionResultData.ErrorInConnection) {
                    ConnectionResultData.ConnectionStateCode = ConectionResultEnum.Error;
                    return ConnectionResultData;
                }
                else {
                    ConnectionResultData.ConnectionStateCode = ConectionResultEnum.Connected;
                    return ConnectionResultData;
                }
            })
                .catch((connectionError) => {
                if (ConnectionErrorsEnum.ERROR_NO_WORKING_SERVERS === connectionError) {
                    return {
                        Connected: false,
                        ConnectionStateCode: ConectionResultEnum.Error,
                        ErrorCode: ConnectionErrorsEnum.ERROR_NO_WORKING_SERVERS,
                        Text: 'screen.LoginScreen.Error.noWorkingServers',
                        ErrorInConnection: true
                    };
                }
                return {
                    Connected: false,
                    ConnectionStateCode: ConectionResultEnum.Error,
                    ErrorCode: ConnectionErrorsEnum.ERROR_UNKNOWN,
                    Text: 'connect.connection.unknown.error',
                    ErrorInConnection: connectionError
                };
            });
        });
    }
    CopyStreamLinks(firstDecoder, secondDecoder) {
        secondDecoder.FInstrumentDecodeMap = firstDecoder.FInstrumentDecodeMap;
        secondDecoder.FSymbolDecodeMap = firstDecoder.FSymbolDecodeMap;
        secondDecoder.FRouteDecodeMap = firstDecoder.FRouteDecodeMap;
        secondDecoder.FAssetDecodeMap = firstDecoder.FAssetDecodeMap;
        secondDecoder.FIdRouteDecodeMap = firstDecoder.FIdRouteDecodeMap;
        secondDecoder.FQuoteRouteMap = firstDecoder.FQuoteRouteMap;
        secondDecoder.FSourceDecodeMap = firstDecoder.FSourceDecodeMap;
    }
    GetConnectionCredentials(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.login = params.login;
            this.loginParams = params;
            const stream = new ProcessorWorker(ProcessorWorker.MODE_AUTHENTICATION_REQUEST);
            stream.OnNewMessageDelegate = this.MessageProcess.bind(this);
            stream.OnError = this.ErrorOccurred.bind(this);
            this.EPStream = stream;
            // Full logingng
            if (this.FullLogSubscribed) {
                this.EPStream.FullLogHandler = this.FullLogHandler;
            }
            return yield this.TryGetConnectionCredentials(stream, params, 0);
        });
    }
    TryGetConnectionCredentials(stream, params, connectionNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const me = this;
            return yield new Promise(function (resolve, reject) {
                return __awaiter(this, void 0, void 0, function* () {
                    stream.OnError = reject;
                    yield stream.ConnectToServer(params.ServerAdressesArray[connectionNumber], params).then(function (data) {
                        resolve(data);
                    });
                });
            }).catch(function () {
                return __awaiter(this, void 0, void 0, function* () {
                    if (params.ServerAdressesArray.length - 1 !== connectionNumber) {
                        return yield me.TryGetConnectionCredentials(stream, params, ++connectionNumber);
                    }
                    return yield Promise.reject(ConnectionErrorsEnum.ERROR_NO_WORKING_SERVERS);
                });
            });
        });
    }
    RefreshAccessToken(ConnectParams, fromReconnect) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = ConnectParams.ConnectParams;
            const stream = new ProcessorWorker(ProcessorWorker.MODE_AUTHENTICATION_REQUEST);
            if (this.FullLogSubscribed) {
                stream.FullLogHandler = this.FullLogHandler;
            }
            stream.isSSL = params.isSSL;
            return yield this.InProcessRefreshAccessToken(stream, ConnectParams, fromReconnect, 0);
        });
    }
    InProcessRefreshAccessToken(stream, ConnectParams, fromReconnect, connectionNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                stream.siteAddres = ConnectParams.ConnectParams.ServerAdressesArray[connectionNumber];
                const opened = yield new Promise((resolve, reject) => {
                    stream.OnError = (err) => {
                        reject(err);
                    };
                    stream.OpenWS().then(resolve).catch(reject);
                });
                if (!opened) {
                    return { StreamOpened: false };
                }
                const TokenDataObj = yield stream.SendRefreshTokenMsg(ConnectParams.ConnectResultData.refreshToken);
                stream.Disconnect();
                return TokenDataObj;
            }
            catch (_a) {
                if (ConnectParams.ConnectParams.ServerAdressesArray.length - 1 !== connectionNumber) {
                    return yield this.InProcessRefreshAccessToken(stream, ConnectParams, fromReconnect, ++connectionNumber);
                }
                return { StreamOpened: false };
            }
        });
    }
    DisconnectProcessPromise(isNoNActivity) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.EPStream) {
                this.EPStream.Disconnect(isNoNActivity);
            }
            this.EPStream = null;
            let keys = Object.keys(this.tradeStreams);
            for (let i = 0, len = keys.length; i < len; i++) {
                if (this.tradeStreams[keys[i]]) {
                    this.tradeStreams[keys[i]].Disconnect(isNoNActivity);
                    this.tradeStreams[keys[i]] = null;
                }
            }
            keys = Object.keys(this.quoteStreams);
            for (let i = 0, len = keys.length; i < len; i++) {
                if (this.quoteStreams[keys[i]]) {
                    this.quoteStreams[keys[i]].Disconnect(isNoNActivity);
                    this.quoteStreams[keys[i]] = null;
                }
            }
            yield Promise.resolve();
        });
    }
    CloseStreams() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.EPStream) {
                this.EPStream.CloseStream();
            }
            this.EPStream = null;
            let keys = Object.keys(this.tradeStreams);
            for (let i = 0, len = keys.length; i < len; i++) {
                if (this.tradeStreams[keys[i]]) {
                    this.tradeStreams[keys[i]].CloseStream();
                    this.tradeStreams[keys[i]] = null;
                }
            }
            keys = Object.keys(this.quoteStreams);
            for (let i = 0, len = keys.length; i < len; i++) {
                if (this.quoteStreams[keys[i]]) {
                    this.quoteStreams[keys[i]].CloseStream();
                    this.quoteStreams[keys[i]] = null;
                }
            }
            yield Promise.resolve();
        });
    }
    GetHistoryPromise(historyParams, ConnectParams, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            const intervals = yield this.CreateHistoryRequest_Normal(historyParams, historyParams.route, ConnectParams, signal);
            return intervals;
        });
    }
    SendRequestToServer(stream, historyParams, routeId, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            stream.OnNewMessageDelegate = this.MessageProcess.bind(this);
            return yield stream.SendRequestToServer(historyParams, routeId, signal).then(function (result) {
                return __awaiter(this, void 0, void 0, function* () {
                    stream.Disconnect();
                    return yield Promise.resolve(result);
                });
            });
        });
    }
    CreateHistoryRequest_Normal(historyParams, routeId, ConnectParams, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (historyParams.NeedApplySpreadPlan) {
                if (historyParams.NeedLoadSecondPartOfHistory) {
                    return yield this.RequestWithApplyingSpreadPlan(historyParams, routeId, ConnectParams, signal);
                }
                const stream = this.PrepareHistoryStream(ConnectParams);
                const opened = yield stream.OpenWS();
                if (opened) {
                    this.CopyStreamLinks((_a = this.stream) === null || _a === void 0 ? void 0 : _a.FMsgDecoder, stream.FMsgDecoder);
                    const intervals = yield this.SendRequestToServer(stream, historyParams, routeId, signal);
                    if (historyParams.TimeFrameInfo.HistoryType === HistoryType.BID) {
                        stream.ApplySpreadToBaseInterval(historyParams, intervals, null, historyParams.Instrument);
                    }
                    else {
                        stream.ApplySpreadToBaseInterval(historyParams, null, intervals, historyParams.Instrument);
                    }
                    return intervals;
                }
                return [];
            }
            else {
                const stream = this.PrepareHistoryStream(ConnectParams);
                const opened = yield stream.OpenWS();
                if (opened) {
                    this.CopyStreamLinks((_b = this.stream) === null || _b === void 0 ? void 0 : _b.FMsgDecoder, stream.FMsgDecoder);
                    const intervals = yield this.SendRequestToServer(stream, historyParams, routeId, signal);
                    return intervals;
                }
                return [];
            }
        });
    }
    RequestWithApplyingSpreadPlan(historyParams, routeId, ConnectParams, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            const bidStream = this.PrepareHistoryStream(ConnectParams);
            const askStream = this.PrepareHistoryStream(ConnectParams);
            const okAstream = askStream.OpenWS().then(function (opened) {
                if (opened) {
                    this.CopyStreamLinks(this.stream.FMsgDecoder, askStream.FMsgDecoder);
                    const tmpHistoryParams = new ReloadHistoryParams(historyParams);
                    const tf = new TFInfo();
                    tf.Periods = historyParams.TimeFrameInfo.Periods;
                    tf.HistoryType = HistoryType.ASK;
                    tmpHistoryParams.TimeFrameInfo = tf;
                    return this.SendRequestToServer(askStream, tmpHistoryParams, routeId, signal);
                }
                return Promise.resolve([]);
            }.bind(this));
            const okBstream = bidStream.OpenWS().then(function (opened) {
                if (opened) {
                    this.CopyStreamLinks(this.stream.FMsgDecoder, bidStream.FMsgDecoder);
                    const tmpHistoryParams = new ReloadHistoryParams(historyParams);
                    const tf = new TFInfo();
                    tf.Periods = historyParams.TimeFrameInfo.Periods;
                    tf.HistoryType = HistoryType.BID;
                    tmpHistoryParams.TimeFrameInfo = tf;
                    return this.SendRequestToServer(bidStream, tmpHistoryParams, routeId, signal);
                }
                return Promise.resolve([]);
            }.bind(this));
            return yield Promise.resolve(Promise.all([okBstream, okAstream]).then(function (results) {
                const BidsCollection = results[0];
                const AsksCollection = results[1];
                askStream.ApplySpreadToBaseInterval(historyParams, BidsCollection, AsksCollection, historyParams.Instrument);
                if (historyParams.TimeFrameInfo.HistoryType === HistoryType.ASK) {
                    return AsksCollection;
                }
                else {
                    return BidsCollection;
                }
            }));
        });
    }
    PrepareHistoryStream(ConnectParams) {
        const params = ConnectParams.ConnectParams;
        const stream = new HistoryProcessorWorker();
        if (this.FullLogSubscribed) {
            stream.FullLogHandler = this.FullLogHandler;
        }
        const isSSL = params.isSSL;
        const [historyNodeAddress, supportedAggregations] = this.GetHistoryNode(isSSL);
        stream.isSSL = isSSL;
        stream.siteAddres = historyNodeAddress;
        stream.setSupportedAggregations(supportedAggregations);
        return stream;
    }
    GetHistoryNode(isSSL) {
        const histClusterNodeGroups = this.ClusterNodesDict.getClusterNodeGroupsByMode(ProcessorWorker.MODE_HISTORYSTREAM);
        if (histClusterNodeGroups.length === 0) {
            return '';
        }
        const firstHistoryClusterNodeGroup = histClusterNodeGroups[0];
        const nodeUrlPair = firstHistoryClusterNodeGroup.GetUrlsPair();
        if (!nodeUrlPair) {
            return '';
        }
        const historyNodeAddress = isSSL ? nodeUrlPair.useSSL : nodeUrlPair.noSSL;
        const supportedAggregations = firstHistoryClusterNodeGroup.SupportedAggregationsGroups();
        return [historyNodeAddress, supportedAggregations];
    }
    GenerateReportPromise(reportId, paramDict) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            // TODO.
            return yield ((_a = this.stream) === null || _a === void 0 ? void 0 : _a.generateReportPromise(reportId, paramDict));
        });
    }
    GetRouteIdByName(name) {
        var _a;
        if ((_a = this.stream) === null || _a === void 0 ? void 0 : _a.FMsgDecoder.IdRouteDecodeMap[name]) {
            return this.stream.FMsgDecoder.IdRouteDecodeMap[name];
        }
        return -1;
    }
    MessageProcess(message) {
        if (message.Code === Message.CODE_PFIX_PROPERTY_MESSAGE && message.Name === FINISH_BLOCK_TRANSFER) {
            const finished = this.CheckAllFinishBlockTransfer();
            if (finished) {
                this.SubscribeCrossRates();
            }
            if (!finished) {
                return;
            }
        }
        if (message.Code === Message.CODE_PFIX_PROPERTY_MESSAGE && message.Name === 'LOGOUT') {
            void this.Disconnect(message.Value);
        }
        if (message.Code === Message.CODE_ROUTE) {
            let urlFromMSG = '';
            if (message.QuoteServerAddress) {
                urlFromMSG = message.QuoteServerAddress.split('=')[0];
            }
            const QSI = message.QuoteServerInfo;
            let urlItem = null;
            if (QSI) {
                const quoteNode = this.ClusterNodesDict.getClusterNodeGroupsById(ProcessorWorker.MODE_QUOTESTREAM, QSI.NodeId);
                if (quoteNode) {
                    urlItem = quoteNode.GetUrlsPair();
                }
            }
            if (urlItem) {
                if (this.loginParams.isSSL) {
                    urlFromMSG = urlItem.useSSL;
                }
                else {
                    urlFromMSG = urlItem.noSSL;
                }
            }
            const item = this.quoteStreams[urlFromMSG];
            if (item) {
                item.RoutesSupported[message.Name] = true;
            }
            else {
                const streamsKeys = Object.keys(this.quoteStreams);
                if (streamsKeys.length === 1) {
                    // single server fix
                    const item = this.quoteStreams[streamsKeys[0]];
                    if (item) {
                        item.RoutesSupported[message.Name] = true;
                    }
                }
            }
        }
        this.NotifyListeners(message);
    }
    SubscribeCrossRates() {
        const validQuoteStream = this.GetValidQuoteStreamForSubscribeCrossRates();
        if (validQuoteStream !== null) {
            validQuoteStream.IsSubcribeOnCrossRates = true;
            validQuoteStream.SubscribeCrossRates();
        }
    }
    GetValidQuoteStreamForSubscribeCrossRates() {
        let validQuoteStream = null;
        const streams = this.quoteStreams;
        const keys = Object.keys(streams);
        if (keys.length > 0) {
            const cPfixMsg = streams[keys[0]];
            if (cPfixMsg.IsSubcribeOnCrossRates) {
                return null;
            }
            validQuoteStream = cPfixMsg;
        }
        return validQuoteStream;
    }
    CheckAllFinishBlockTransfer() {
        let finished = true;
        let keys = Object.keys(this.tradeStreams);
        for (let i = 0, len = keys.length; i < len; i++) {
            if (!this.tradeStreams[keys[i]].finished) {
                finished = false;
            }
        }
        keys = Object.keys(this.quoteStreams);
        for (let i = 0, len = keys.length; i < len; i++) {
            if (!this.quoteStreams[keys[i]].finished) {
                finished = false;
            }
        }
        return finished;
    }
    SubscribeSymbol(InstrumentId, route, quoteType, forse, isDataSource) {
        const qS = this.GetQuoteStreamByRoute(route);
        if (qS) {
            qS.SubscribeQuote(InstrumentId, route, quoteType, forse, isDataSource);
        }
    }
    UnsubscribeSymbol(InstrumentId, route, quoteType, forse, isDataSource) {
        const qS = this.GetQuoteStreamByRoute(route);
        if (qS) {
            qS.UnsubscribeQuote(InstrumentId, route, quoteType, forse, isDataSource);
        }
    }
    GetQuoteStreamByRoute(route) {
        const keys = Object.keys(this.quoteStreams);
        let qS = null;
        if (!this.stream) {
            return null;
        }
        const decoder = this.stream.FMsgDecoder;
        const necessaryRoute = decoder.GetRouteById(decoder.GetRouteQuoteId(route));
        for (let i = 0, len = keys.length; i < len; i++) {
            if (this.quoteStreams[keys[i]].RoutesSupported[necessaryRoute]) {
                qS = this.quoteStreams[keys[i]];
                break;
            }
        }
        return qS;
    }
    SubscribeOnFullLoging(handler) {
        let keys = Object.keys(this.tradeStreams);
        for (let i = 0, len = keys.length; i < len; i++) {
            if (this.tradeStreams[keys[i]]) {
                this.tradeStreams[keys[i]].FullLogHandler = handler;
            }
        }
        keys = Object.keys(this.quoteStreams);
        for (let i = 0, len = keys.length; i < len; i++) {
            if (this.quoteStreams[keys[i]]) {
                this.quoteStreams[keys[i]].FullLogHandler = handler;
            }
        }
        this.FullLogHandler = handler;
        this.FullLogSubscribed = true;
    }
    UnSubscribeOnFullLoging() {
        let keys = Object.keys(this.tradeStreams);
        for (let i = 0, len = keys.length; i < len; i++) {
            if (this.tradeStreams[keys[i]]) {
                this.tradeStreams[keys[i]].FullLogHandler = null;
            }
        }
        keys = Object.keys(this.quoteStreams);
        for (let i = 0, len = keys.length; i < len; i++) {
            if (this.quoteStreams[keys[i]]) {
                this.quoteStreams[keys[i]].FullLogHandler = null;
            }
        }
        this.FullLogHandler = null;
        this.FullLogSubscribed = false;
    }
    GetMessagesList() {
        return Message.CodesString;
    }
    SendPing() {
        return __awaiter(this, void 0, void 0, function* () {
            let pingPromise = null;
            let keys = Object.keys(this.tradeStreams);
            for (let i = 0, len = keys.length; i < len; i++) {
                if (this.tradeStreams[keys[i]]) {
                    pingPromise = this.tradeStreams[keys[i]].SendPing();
                }
            }
            keys = Object.keys(this.quoteStreams);
            for (let i = 0, len = keys.length; i < len; i++) {
                if (this.quoteStreams[keys[i]]) {
                    this.quoteStreams[keys[i]].SendPing();
                }
            }
            if (pingPromise) {
                return pingPromise;
            }
            else {
                return yield Promise.resolve(0);
            }
        });
    }
    ChangePassword(curPwd, newPwd, UserID, verificationPassword, accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.ChangePassword(curPwd, newPwd, UserID, verificationPassword, accessToken);
            }
            return yield Promise.resolve(null);
        });
    }
    static SendSOAPRequest(request, connectTo, FullLogHandler) {
        return __awaiter(this, void 0, void 0, function* () {
            const stream = new ProcessorWorker(ProcessorWorker.MODE_TRADESTREAM);
            if (FullLogHandler) {
                stream.FullLogHandler = FullLogHandler;
            }
            stream.isSSL = connectTo.isSSL;
            stream.siteAddres = connectTo.address;
            return yield stream.OpenWS().then(function (opened) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (opened) {
                        return yield stream.SendSOAPRequest(request).then(function (result) {
                            return __awaiter(this, void 0, void 0, function* () {
                                stream.Disconnect();
                                return yield Promise.resolve(result);
                            });
                        });
                    }
                    return yield Promise.resolve(null);
                });
            });
        });
    }
    static SendMessageToVendor(url, isSSL, msgType, dataForMsg, FullLogHandler, mode) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield ProcessorWorker.SendMessageToVendor(url, isSSL, msgType, dataForMsg, FullLogHandler, mode);
        });
    }
    sendOutputMessageAsync(message) {
        return __awaiter(this, void 0, void 0, function* () {
            const stream = this.stream;
            if (isNullOrUndefined(stream)) {
                return yield Promise.resolve(null);
            }
            switch (message.Code) {
                case Message.CODE_TRADING_WEBHOOK_REQUEST:
                    return (yield PFixTradingWebhookRequestMessage.sendMessageAsync(stream.sendMessageAsync, message));
                case Message.CODE_TRADING_WEBHOOK_LIST_REQUEST:
                    return (yield PFixTradingWebhookListRequest.sendMessageAsync(stream.sendMessageAsync, message));
                case Message.CODE_OTT_REQUEST:
                    return (yield PFixOTTRequestMessage.sendMessageAsync(stream.sendMessageAsync, message));
                default:
                    return yield Promise.resolve(null);
            }
        });
    }
    ChangeTradingPassword(curPwd, newPwd) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.ChangeTradingPassword(curPwd, newPwd);
            }
            return yield Promise.resolve(null);
        });
    }
    AccountOperationRequest(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.AccountOperationRequest(data);
            }
            return yield Promise.resolve(null);
        });
    }
    SendAlertToServer(alertData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!alertData.Account) {
                yield Promise.resolve();
                return;
            }
            const stream = this.getTradeStream(alertData.Account.ClusterNode);
            if (stream) {
                stream.SendAlertToServer(alertData);
                return;
            }
            yield Promise.resolve();
        });
    }
    MakeAlertAction(alertData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!alertData.Account) {
                yield Promise.resolve();
                return;
            }
            const stream = this.getTradeStream(alertData.Account.ClusterNode);
            if (stream) {
                stream.MakeAlertAction(alertData);
                return;
            }
            yield Promise.resolve();
        });
    }
    // #region Trading
    placeOrder(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const isAllowTrading = yield this.validateTradingAsync([data.account.userLogin], data.placedFrom);
            if (!isAllowTrading) {
                yield Promise.resolve();
                return;
            }
            const stream = this.getTradeStream(data.account.ClusterNode);
            if (stream) {
                stream.placeOrder(data);
                return;
            }
            yield Promise.resolve();
        });
    }
    placeOrderAsync(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const isAllowTrading = yield this.validateTradingAsync([data.account.userLogin], data.placedFrom);
            if (!isAllowTrading) {
                yield Promise.resolve();
                return;
            }
            const stream = this.getTradeStream(data.account.ClusterNode);
            if (stream) {
                return yield stream.placeOrderAsync(data);
            }
            else {
                yield Promise.resolve();
            }
        });
    }
    multiplyPlaceOrdersAsync(multiplyOrdersWrapper) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestsArray = [];
            const accountsArray = multiplyOrdersWrapper.GetAllAccounts();
            const isAllowTrading = yield this.validateTradingAsync(accountsArray.map((account) => account.userLogin), multiplyOrdersWrapper.placedFrom);
            if (!isAllowTrading) {
                yield Promise.resolve();
                return;
            }
            for (const account of accountsArray) {
                const stream = this.getTradeStream(account.ClusterNode);
                if (stream !== null) {
                    const req = stream.multiplyPlaceOrdersAsync(multiplyOrdersWrapper.GetArrayByAccount(account), multiplyOrdersWrapper.placedFrom);
                    requestsArray.push(req);
                }
                else {
                    requestsArray.push(Promise.resolve([]));
                }
            }
            // Promise.all returns array of results. so we have [[],[],...[]];
            // need concat in sigle array [...]
            const response = yield Promise.all(requestsArray);
            const result = [];
            for (const resp of response) {
                result.push(...resp);
            }
            return result;
        });
    }
    SendInformationMessage(data) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if ((_a = this.stream) === null || _a === void 0 ? void 0 : _a.SendInformationMessage) {
                this.stream.SendInformationMessage(data);
                return;
            }
            yield Promise.resolve();
        });
    }
    getTradeStream(key) {
        var _a;
        return (_a = this.tradeStreams[key]) !== null && _a !== void 0 ? _a : null;
    }
    // TODO. Interface.
    cancelOrder(order, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const isAllowTrading = yield this.validateTradingAsync([order.Account.userLogin], placedFrom);
            if (!isAllowTrading) {
                yield Promise.resolve();
                return;
            }
            const stream = this.getTradeStream(order.Account.ClusterNode);
            if (stream) {
                (_a = this.stream) === null || _a === void 0 ? void 0 : _a.cancelOrder(order, placedFrom);
            }
            yield Promise.resolve();
        });
    }
    closePositions(closePositionData, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const accounts = [];
            for (const closePosition of closePositionData) {
                const userLogin = closePosition.position.Account.userLogin;
                if (!accounts.includes(userLogin)) {
                    accounts.push(userLogin);
                }
            }
            const isAllowTrading = yield this.validateTradingAsync(accounts, placedFrom);
            if (!isAllowTrading) {
                return;
            }
            const closePositionsDataByClusterNode = new Map();
            for (const closePosition of closePositionData) {
                const clusterNode = closePosition.position.Account.ClusterNode;
                if (!closePositionsDataByClusterNode.has(clusterNode)) {
                    closePositionsDataByClusterNode.set(clusterNode, []);
                }
                closePositionsDataByClusterNode.get(clusterNode).push(closePosition);
            }
            for (const [clusterNode, closePositionDataByClusterNode] of closePositionsDataByClusterNode.entries()) {
                const stream = this.getTradeStream(clusterNode);
                if (stream) {
                    stream.closePositions(closePositionDataByClusterNode, placedFrom);
                }
            }
        });
    }
    modifyPosition(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const isAllowTrading = yield this.validateTradingAsync([data.account.userLogin], data.placedFrom);
            if (!isAllowTrading) {
                yield Promise.resolve();
                return;
            }
            const stream = this.getTradeStream(data.account.ClusterNode);
            if (stream) {
                return stream.modifyPosition(data);
            }
            yield Promise.resolve();
        });
    }
    reversePosition(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const isAllowTrading = yield this.validateTradingAsync([data.account.userLogin], data.placedFrom);
            if (!isAllowTrading) {
                yield Promise.resolve();
                return;
            }
            const stream = this.getTradeStream(data.account.ClusterNode);
            if (stream != null) {
                yield stream.reversePosition(data);
                return;
            }
            yield Promise.resolve();
        });
    }
    modifyOrder(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const isAllowTrading = yield this.validateTradingAsync([data.account.userLogin], data.placedFrom);
            if (!isAllowTrading) {
                return false;
            }
            const stream = this.getTradeStream(data.account.ClusterNode);
            if (stream) {
                return yield stream.replaceOrder(data);
            }
            return false;
        });
    }
    // TODO. Refactor. Move to modifyOrder()?
    changeOrderToMarket(order, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const isAllowTrading = yield this.validateTradingAsync([order.Account.userLogin], placedFrom);
            if (!isAllowTrading) {
                yield Promise.resolve();
                return;
            }
            const stream = this.getTradeStream(order.Account.ClusterNode);
            if (stream) {
                stream.changeOrderToMarket(order, placedFrom);
                return;
            }
            yield Promise.resolve();
        });
    }
    modifyPositionProductType(pos, productType, quantity) {
        return __awaiter(this, void 0, void 0, function* () {
            const isAllowTrading = yield this.validateTradingAsync([pos.Account.userLogin], undefined);
            if (!isAllowTrading) {
                yield Promise.resolve();
                return;
            }
            const stream = this.getTradeStream(pos.Account.ClusterNode);
            if (stream) {
                yield stream.modifyPositionProductType(pos.PositionId, productType, quantity);
                return;
            }
            yield Promise.resolve();
        });
    }
    sendTradePassword(pass, ExternalResourse) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.sendTradePassword(pass, ExternalResourse);
            }
            else {
                return yield Promise.resolve(null);
            }
        });
    }
    // #endregion Trading
    // #region NFL - NonFixedList
    GetInstrumentList(patern, exchangeIDs, instrumentTypes, aliasLanguage, oldLookupType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.GetInstrumentList(patern, exchangeIDs, instrumentTypes, aliasLanguage, oldLookupType);
            }
        });
    }
    GetOptionsList(patern, exchangeIDs, instrumentTypes, aliasLanguage) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.GetOptionsList(patern, exchangeIDs, instrumentTypes, aliasLanguage);
            }
        });
    }
    GetNonFixedInstrumentStrikes(ContractID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.GetNonFixedInstrumentStrikes(ContractID);
            }
        });
    }
    getInstrumentById(instrumentID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.getInstrumentById(instrumentID);
            }
        });
    }
    getInstrumentByInstrumentTradableID_NFL(InstrumentTradableID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.getInstrumentByInstrumentTradableID_NFL(InstrumentTradableID);
            }
        });
    }
    GetNonFixedInstrumentListByAssetName(AsssetName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.GetNonFixedInstrumentListByAssetName(AsssetName);
            }
        });
    }
    GetYieldRate(instrumentID, routeID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.GetYieldRate(instrumentID, routeID);
            }
        });
    }
    SendExerciseRequest(positionID, status) {
        if (this.stream) {
            this.stream.SendExerciseRequest(positionID, status);
        }
    }
    SendInactivityPeriodState(msgText) {
        if (this.stream) {
            this.stream.SendInactivityPeriodState(msgText);
        }
    }
    SendLogsWhenSettingsWasChanged(propsForLog) {
        if (this.stream) {
            this.stream.SendLogsWhenSettingsWasChanged(propsForLog);
        }
    }
    SendNewsSubscribeMessage(routeIDArr, subscribeType) {
        if (this.stream) {
            this.stream.SendNewsSubscribeMessage(routeIDArr, subscribeType);
        }
    }
    SendNewsRequestMessage(routeID, number, startTime, endTime) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.SendNewsRequestMessage(routeID, number, startTime, endTime);
            }
        });
    }
    SendCustomListRequest(userID, listType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.SendCustomListRequest(userID, listType);
            }
        });
    }
    SendSubscriptionStrategyRequest(tradingSystemId) {
        if (this.stream) {
            this.stream.SendSubscriptionStrategyRequest(tradingSystemId);
        }
    }
    SendSnapshotRequestMessageAsync(tradableID, routeID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.SendSnapshotRequestMessageAsync(tradableID, routeID);
            }
        });
    }
    SendMarginRequest(parmeters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.SendMarginRequest(parmeters);
            }
        });
    }
    SendAccountFollowerRequest(args) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.SendAccountFollowerRequest(args);
            }
        });
    }
    SendPortfolioStatisticsRequest(accountId, type, startTime, endTime, routeId, instrumentTradableID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.SendPortfolioStatisticsRequest(accountId, type, startTime, endTime, routeId, instrumentTradableID);
            }
        });
    }
    SendPortfolioModelRequest() {
        if (this.stream) {
            this.stream.SendPortfolioModelRequest();
        }
    }
    AlgorithmSubscribeMessage(subscribe_1, algorithmId_1) {
        return __awaiter(this, arguments, void 0, function* (subscribe, algorithmId, toQuoteStream = true) {
            let stream = this.stream;
            if (toQuoteStream) {
                // https://tp.traderevolution.com/entity/109058 comments
                for (const s in this.quoteStreams) {
                    stream = this.quoteStreams[s];
                    break;
                }
            }
            if (stream) {
                yield stream.AlgorithmSubscribeMessage(subscribe, algorithmId);
            }
        });
    }
    GetBrandingRules(brandingKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.GetBrandingRules(brandingKey);
            }
        });
    }
    SendBrokerMessageReport(inputMessage, type) {
        // закоментовано, згодом відновлено  згідно з #110904 (для urgent BM було додано логіювання у #84587, судячи з усього зараз ця логіка вже є застарілою і непотрібною)
        if (this.stream) {
            this.stream.SendBrokerMessageReport(inputMessage, type);
        }
    }
    SendBrokerResponseMessage(brokerMsgID, value, userID, userName, responseType, clusterNode) {
        return __awaiter(this, void 0, void 0, function* () {
            let stream = this.stream;
            if (clusterNode) {
                stream = this.getTradeStream(clusterNode) || stream;
            }
            if (stream) {
                return yield stream.SendBrokerResponseMessage(brokerMsgID, value, userID, userName, responseType);
            }
        });
    }
    SendBrokerMessageHistoryRequest(userID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.SendBrokerMessageHistoryRequest(userID);
            }
        });
    }
    GetInstrument() { }
    // #endregion NFL
    SendProductDocumentRequest(Id) {
        return __awaiter(this, void 0, void 0, function* () {
            const stream = this.stream;
            if (stream) {
                return yield stream.SendProductDocumentRequest(Id);
            }
            yield Promise.resolve();
        });
    }
    SendProductSubscriptionRequest(subsData) {
        return __awaiter(this, void 0, void 0, function* () {
            const stream = this.stream;
            if (stream) {
                yield stream.SendProductSubscriptionRequest(subsData);
                return;
            }
            yield Promise.resolve();
        });
    }
    SendSubscriptionHistoryReques(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const stream = this.stream;
            if (stream) {
                return yield stream.SendSubscriptionHistoryReques(from, to);
            }
            yield Promise.resolve();
        });
    }
    SendDataSourceSubscriptionMessage(InstrumentId, route, service, subscriptionActionType, targetTrInsID) {
        const qS = this.GetQuoteStreamByRoute(route);
        if (qS) {
            return qS.SendDataSourceSubscriptionMessage(InstrumentId, route, service, subscriptionActionType, targetTrInsID);
        }
    }
    SendCloseAccountRequestMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.SendCloseAccountRequestMessage();
            }
        });
    }
    SendCloseAccountCancelRequestMessage(closeAccountRequestID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.SendCloseAccountCancelRequestMessage(closeAccountRequestID);
            }
        });
    }
    SendGoogleAuthRequest(userID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.SendGoogleAuthRequest(userID);
            }
        });
    }
    SendGoogleAuthConfirmRequest(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stream) {
                return yield this.stream.SendGoogleAuthConfirmRequest(data);
            }
        });
    }
    SendQuotesRequest(tradableIdRouteIdArray) {
        const streamsMap = new Map();
        for (let i = 0; i < tradableIdRouteIdArray.length; i++) {
            const tradableIdRouteId = tradableIdRouteIdArray[i];
            const quoteStream = this.GetQuoteStreamByRoute(tradableIdRouteId.routeId);
            if (isNullOrUndefined(quoteStream)) {
                continue;
            }
            let arrayByStream = streamsMap.get(quoteStream);
            if (isNullOrUndefined(arrayByStream)) {
                arrayByStream = [];
                streamsMap.set(quoteStream, arrayByStream);
            }
            arrayByStream.push(tradableIdRouteId);
        }
        for (const [stream, arrayByStream] of streamsMap) {
            stream.SendQuotesRequest(arrayByStream);
        }
    }
    generateRejectMessage(message) {
        var _a;
        const reportMessage = new DirectReportMessage();
        reportMessage.source = ReportMessageSource.BusinessRejectMessage;
        reportMessage.Name = 'general.trading.refused';
        reportMessage.Data = [['Error', message]];
        reportMessage.reject = true;
        (_a = this.stream) === null || _a === void 0 ? void 0 : _a.Notify(reportMessage);
    }
    validateTradingAsync(loginArray, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const validator = this.tradingValidator;
            if (isNullOrUndefined(validator)) {
                return true;
            }
            for (let i = 0; i < loginArray.length; i++) {
                const login = loginArray[i];
                const result = yield validator.validateTradingAsync(this, login, placedFrom);
                if (!result) {
                    return false;
                }
            }
            return true;
        });
    }
}
